import React from 'react';

const NoSellerAssistance = () => {
  return (
    <span>
      Buyer will pay costs affiliated with the buyers side of the transaction,
      including the Unbeatable Loans LLC contract negotiation fee. There will ne
      no buyers agent commission.
    </span>
  );
};

export default NoSellerAssistance;
